import { AnimatePresence, motion } from 'framer-motion';

import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';

export function ScrollToBottomButton({ visible, onClick }: { visible: boolean; onClick: () => void }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
        >
          <Button
            variant={'white'}
            className="size-9 rounded-full shadow-lg/4 ring-offset-transparent focus-visible:ring-offset-white"
            onClick={onClick}
          >
            <Icon className="lucide--arrow-down" />
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
